export const SAGE_ITEM_CODE_HELPER =
  'Required for Sage invoicing. Use the item code from Sage, not the Sage id.';

export const SAGE_ITEM_CODE_MISSING_WARNING =
  'No Sage item code. Invoices for this pack will fail.';

/** Null, missing, or whitespace-only codes are unmapped. A real code such as "0" is kept. */
export function isBlankSageItemCode(code: unknown): boolean {
  if (code == null) return true;
  return String(code).trim() === '';
}

/** Trimmed item code for the create/edit body. Empty string clears the link. */
export function sageItemCodeForApi(value: unknown): string {
  if (value == null) return '';
  return String(value).trim();
}

/** Code on a pack from the list. The API may send sage_item_code or sageItemCode. */
export function readSageItemCode(source: object | null | undefined): string {
  if (!source) return '';
  const record = source as { sage_item_code?: unknown; sageItemCode?: unknown };
  return sageItemCodeForApi(record.sage_item_code ?? record.sageItemCode);
}

/**
 * Put codes saved in this screen onto the pack list.
 * A code just saved wins for that pack, including an empty string that clears it.
 * Other packs keep a non-blank API value (sage_item_code or sageItemCode).
 */
export function withSavedSageItemCode<T extends { id: number; sage_item_code?: string | null }>(
  packs: T[] | null | undefined,
  saved: ReadonlyMap<number, string> | null | undefined
): T[] {
  if (!packs) return [];
  let changed = false;
  const next = packs.map((pack) => {
    const hasSaved = saved?.has(pack.id) ?? false;
    const code = hasSaved ? (saved!.get(pack.id) ?? '') : readSageItemCode(pack);
    if ((pack.sage_item_code ?? '') !== code) {
      changed = true;
      return { ...pack, sage_item_code: code };
    }
    return pack;
  });
  return changed ? next : packs;
}
